export default __webpack_public_path__ + "7839b85f701d2161993a855e4c6647e8.png";